import type { ReactNode } from 'react';

export const symbol_streetview: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M578.5-578.5Q520-637 520-720t58.5-141.5Q637-920 720-920t141.5 58.5Q920-803 920-720t-58.5 141.5Q803-520 720-520t-141.5-58.5ZM147-147q-13-9-20-23t-7-30v-560q0-34 23-57t57-23h269q-14 25-21.5 55t-7.5 65q0 56 22 108t60 90L147-147Zm333 27v-218q0-44 26.5-77.5T576-457q32-8 69-10.5t75-2.5q35 0 64.5 2t55.5 8v260q0 34-23 57t-57 23H480Z"
		/>
	</svg>
);
